import { gql } from '@apollo/client';

const PATIENT_RETURN_CONFIG_QUERY = gql`
  query patientReturnConfig {
    patientReturnConfig {
      receivedItems {
        name
        position
      }
      packageShipmentLabel
    }
  }
`;

export default PATIENT_RETURN_CONFIG_QUERY;
